/* ==========================================================================
   WEBLY AGENCY OS — interactions du theme
   Vanilla, sans dependance. Chaque composant s'initialise UNIQUEMENT si son
   markup existe, et se re-initialise sur shopify:section:load pour rester
   utilisable dans l'editeur Shopify.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hover = window.matchMedia && window.matchMedia('(hover:hover)').matches;
  var W = window.Webly || {};

  /* Chaque composant enregistre ici son nettoyage : sans cela, l'editeur
     Shopify empilerait un observer de plus a chaque rechargement de section. */
  var cleanups = [];
  function onCleanup(fn) { cleanups.push(fn); }

  function announce(msg) {
    var live = $('#a11y-live');
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60); }
  }
  window.weblyAnnounce = announce;

  /* ====================================================== OVERLAYS
     Un gestionnaire unique pour modales, tiroir et lightbox : le verrouillage
     du scroll, le piege a focus et la pile de z-index doivent etre coherents,
     sinon deux overlays ouverts se disputent le focus et le scroll reste
     bloque apres fermeture. */
  var Overlay = (function () {
    var pile = [];
    var scrollY = 0;
    var SELECTEURS = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

    function focusables(el) {
      return $$(SELECTEURS, el).filter(function (n) {
        return n.offsetWidth || n.offsetHeight || n.getClientRects().length;
      });
    }

    function piege(e) {
      if (e.key !== 'Tab' || !pile.length) return;
      var el = pile[pile.length - 1].el;
      var f = focusables(el);
      if (!f.length) { e.preventDefault(); return; }
      var premier = f[0], dernier = f[f.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }

    function echap(e) {
      if (e.key === 'Escape' && pile.length) { e.stopPropagation(); fermer(); }
    }

    function verrouille() {
      // On fige la page en `position:fixed` pour empecher le scroll d'arriere-plan
      // sur iOS, ou `overflow:hidden` seul ne suffit pas. La barre de defilement
      // est compensee pour que la page ne saute pas lateralement a l'ouverture.
      scrollY = window.pageYOffset;
      var barre = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY + 'px';
      document.body.style.width = '100%';
      if (barre > 0) document.body.style.paddingRight = barre + 'px';
      document.body.classList.add('no-scroll');
    }
    function deverrouille() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
      document.body.classList.remove('no-scroll');
      window.scrollTo(0, scrollY);
    }

    function ouvrir(el, opts) {
      if (!el) return;
      opts = opts || {};
      if (!pile.length) {
        verrouille();
        document.addEventListener('keydown', piege, true);
        document.addEventListener('keydown', echap, true);
      }
      pile.push({ el: el, retour: document.activeElement, onClose: opts.onClose });
      el.classList.add('open');
      el.removeAttribute('aria-hidden');
      // Juste apres l'ajout de la classe, le navigateur n'a pas encore
      // recalcule les styles : l'overlay est toujours en `visibility:hidden`,
      // et focus() dans un sous-arbre invisible est sans effet — le clavier
      // resterait bloque derriere la modale.
      // La lecture de offsetWidth force ce recalcul de maniere SYNCHRONE.
      // On evite volontairement requestAnimationFrame : il ne s'execute pas
      // dans un onglet d'arriere-plan, et le focus n'arriverait jamais.
      void el.offsetWidth;
      var f = focusables(el);
      var cible = opts.focus || f[0] || el;
      if (cible === el && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      cible.focus({ preventScroll: true });
    }

    function fermer(cible) {
      if (!pile.length) return;
      var i = cible ? -1 : pile.length - 1;
      if (cible) for (var k = 0; k < pile.length; k++) if (pile[k].el === cible) i = k;
      if (i < 0) return;
      var entree = pile.splice(i, 1)[0];
      entree.el.classList.remove('open');
      entree.el.setAttribute('aria-hidden', 'true');
      if (entree.onClose) entree.onClose();
      if (!pile.length) {
        document.removeEventListener('keydown', piege, true);
        document.removeEventListener('keydown', echap, true);
        deverrouille();
      }
      if (entree.retour && entree.retour.focus) entree.retour.focus({ preventScroll: true });
    }

    return { ouvrir: ouvrir, fermer: fermer, actif: function () { return pile.length > 0; } };
  })();
  window.WeblyOverlay = Overlay;

  /* Fermeture au clic sur le fond, pour tout overlay. */
  document.addEventListener('click', function (e) {
    var ov = e.target.closest ? e.target.closest('.overlay,.drawer-scrim') : null;
    if (ov && e.target === ov) {
      Overlay.fermer(ov.classList.contains('drawer-scrim') ? $('#CartDrawer') : ov);
      if (ov.classList.contains('drawer-scrim')) ov.classList.remove('open');
    }
    var fermeBtn = e.target.closest ? e.target.closest('[data-close]') : null;
    if (fermeBtn) {
      var parent = fermeBtn.closest('.overlay,.drawer');
      if (parent) {
        Overlay.fermer(parent);
        var scrim = $('.drawer-scrim');
        if (scrim) scrim.classList.remove('open');
      }
    }
  });

  /* ====================================================== NAVIGATION */
  function initNav() {
    var nav = $('#SiteHeader');
    if (!nav) return;
    var burger = $('#Burger', nav);
    var menu = $('#MobileMenu');

    function onScroll() { nav.classList.toggle('stuck', window.pageYOffset > 8); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    onCleanup(function () { window.removeEventListener('scroll', onScroll); });

    if (burger && menu) {
      $$('a', menu).forEach(function (a, i) { a.style.setProperty('--i', i); });
      function bascule(ouvert) {
        menu.classList.toggle('open', ouvert);
        nav.classList.toggle('open', ouvert);
        burger.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      }
      burger.addEventListener('click', function () { bascule(!menu.classList.contains('open')); });
      $$('a', menu).forEach(function (a) {
        a.addEventListener('click', function () { bascule(false); });
      });
      document.addEventListener('click', function (e) {
        if (!menu.classList.contains('open')) return;
        if (!menu.contains(e.target) && !burger.contains(e.target)) bascule(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('open')) { bascule(false); burger.focus(); }
      });
    }

    // Indicateur de section active
    var liens = $$('a[href^="#"]', nav).filter(function (a) { return a.getAttribute('href').length > 1; });
    if (!liens.length || !('IntersectionObserver' in window)) return;
    var cibles = liens.map(function (a) { return $(a.getAttribute('href')); }).filter(Boolean);
    if (!cibles.length) return;
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        if (!en.isIntersecting) return;
        liens.forEach(function (a) {
          a.toggleAttribute('aria-current', a.getAttribute('href') === '#' + en.target.id);
        });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    cibles.forEach(function (c) { io.observe(c); });
    onCleanup(function () { io.disconnect(); });
  }

  /* ====================================================== MODE CLAIR / SOMBRE
     Le mode est deja applique par le script synchrone du <head> : ici on ne
     gere que la bascule et la memorisation. Les captures de la demo existent
     en deux jeux, on echange donc aussi leur source. */
  function initScheme() {
    var html = document.documentElement;

    function majBouton() {
      var clair = html.getAttribute('data-scheme') === 'light';
      $$('[data-scheme-toggle]').forEach(function (b) {
        b.setAttribute('aria-pressed', clair ? 'true' : 'false');
        var use = $('[data-scheme-icon] use', b) || $('use', b);
        if (use) use.setAttribute('href', clair ? '#i-sun' : '#i-moon');
      });
    }

    function majCaptures() {
      var clair = html.getAttribute('data-scheme') === 'light';
      // Les deux jeux suivent la meme convention de nommage :
      //   module-<slug>-1400.webp        (sombre, jeu par defaut)
      //   module-<slug>-dark-1400.webp   (capture de l'app en mode sombre)
      // Le jeu "-dark" illustre l'application en sombre : il accompagne donc
      // le mode SOMBRE du site, et le jeu sans suffixe le mode clair.
      $$('img[src*="module-"]').forEach(function (im) {
        var src = im.getAttribute('src') || '';
        var voulu;
        if (clair) {
          voulu = src.replace('-dark-', '-');
        } else if (src.indexOf('-dark-') === -1) {
          // `$` ne fonctionne pas : Shopify suffixe ses assets d'un `?v=...`.
          voulu = src.replace(/-(\d+)\.webp(\?|$)/, '-dark-$1.webp$2');
        } else {
          voulu = src;
        }
        if (voulu !== src) im.setAttribute('src', voulu);
      });
      // La demo redessine sa scene depuis ses propres donnees : on la previent.
      if (typeof window.weblyRedessinerDemo === 'function') window.weblyRedessinerDemo();
    }

    majBouton();

    $$('[data-scheme-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var clair = html.getAttribute('data-scheme') === 'light';
        var neuf = clair ? 'dark' : 'light';
        html.setAttribute('data-scheme', neuf);
        try { localStorage.setItem('webly_scheme', neuf); } catch (e) {}
        majBouton();
        majCaptures();
        announce(neuf === 'light' ? 'Mode clair activé' : 'Mode sombre activé');
      });
    });
  }

  /* ====================================================== REVELATIONS */
  function initReveals() {
    var els = $$('.rv');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    // Filet : un defilement tres rapide ou un onglet ouvert en arriere-plan
    // peut priver l'observateur de son declenchement. Rien ne doit rester
    // invisible definitivement.
    var filet = setTimeout(function () {
      els.forEach(function (e) {
        if (e.getBoundingClientRect().top < window.innerHeight) e.classList.add('in');
      });
    }, 2500);
    onCleanup(function () { io.disconnect(); clearTimeout(filet); });
  }

  /* ====================================================== COMPTEURS
     La valeur finale est ecrite dans le HTML par Liquid : si le JS ne tourne
     pas, le chiffre juste est deja affiche. L'animation ne fait que partir
     de zero pour y revenir, une seule fois. */
  function initCounters() {
    var els = $$('[data-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    if (reduce) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var final = el.textContent;
        var cible = parseFloat(el.getAttribute('data-count'));
        if (isNaN(cible)) return;
        var t0 = 0, duree = 1100;
        function pas(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / duree);
          var v = Math.round(cible * (1 - Math.pow(1 - p, 3)));
          el.textContent = v.toLocaleString('fr-FR');
          if (p < 1) requestAnimationFrame(pas); else el.textContent = final;
        }
        requestAnimationFrame(pas);
      });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
    onCleanup(function () { io.disconnect(); });
  }

  /* ====================================================== FAQ */
  function initFaq() {
    $$('[data-faq]').forEach(function (racine) {
      var solo = racine.getAttribute('data-faq') === 'single';
      var btns = $$('.q-btn', racine);
      btns.forEach(function (btn) {
        var corps = document.getElementById(btn.getAttribute('aria-controls'));
        if (!corps) return;
        btn.addEventListener('click', function () {
          var ouvert = btn.getAttribute('aria-expanded') === 'true';
          if (solo && !ouvert) {
            btns.forEach(function (o) {
              if (o === btn) return;
              var c = document.getElementById(o.getAttribute('aria-controls'));
              o.setAttribute('aria-expanded', 'false');
              if (c) c.style.height = '0px';
            });
          }
          btn.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
          // Hauteur reelle mesuree : `auto` ne s'anime pas.
          corps.style.height = ouvert ? '0px' : corps.firstElementChild.offsetHeight + 'px';
        });
        // Navigation clavier entre questions
        btn.addEventListener('keydown', function (e) {
          var i = btns.indexOf(btn), n = null;
          if (e.key === 'ArrowDown') n = btns[(i + 1) % btns.length];
          else if (e.key === 'ArrowUp') n = btns[(i - 1 + btns.length) % btns.length];
          else if (e.key === 'Home') n = btns[0];
          else if (e.key === 'End') n = btns[btns.length - 1];
          if (n) { e.preventDefault(); n.focus(); }
        });
      });
      // Une reponse ouverte doit suivre le redimensionnement du texte.
      var rz = function () {
        btns.forEach(function (b) {
          if (b.getAttribute('aria-expanded') !== 'true') return;
          var c = document.getElementById(b.getAttribute('aria-controls'));
          if (c) c.style.height = c.firstElementChild.offsetHeight + 'px';
        });
      };
      window.addEventListener('resize', rz);
      onCleanup(function () { window.removeEventListener('resize', rz); });
    });
  }

  /* ============================================ FAQ : repli « Afficher plus »
     Dix questions ouvertes d'un coup decouragent la lecture. On en montre
     quelques-unes, le reste est accessible en un clic — et reste dans le HTML,
     donc indexable et lisible par un lecteur d'ecran. */
  function initFaqRepli() {
    $$('[data-faq-max]').forEach(function (racine) {
      var max = parseInt(racine.getAttribute('data-faq-max'), 10) || 6;
      var qs = $$('.q', racine);
      if (qs.length <= max) return;
      racine.classList.add('is-clamped');
      qs.forEach(function (q, i) { if (i >= max) q.classList.add('beyond'); });

      var wrap = document.createElement('div');
      wrap.className = 'faq-more';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn btn-ghost';
      var reste = qs.length - max;
      btn.innerHTML = '<span class="lbl">Afficher ' + reste + ' question' +
                      (reste > 1 ? 's' : '') + ' de plus</span>';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var ouvert = racine.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        $('.lbl', btn).textContent = ouvert ? 'Afficher moins'
                                            : 'Afficher ' + reste + ' question' + (reste > 1 ? 's' : '') + ' de plus';
      });
      wrap.appendChild(btn);
      racine.parentNode.insertBefore(wrap, racine.nextSibling);
    });
  }

  /* ============================================ CARROUSEL D'AVIS
     Defilement pilote par `scrollTo` sur une piste a accroche native : aucun
     glissement simule, donc le scroll vertical de la page reste intact et le
     rebond iOS est preserve. */
  function initAvis() {
    $$('[data-avis]').forEach(function (racine) {
      var piste = $('[data-avis-piste]', racine);
      if (!piste) return;
      var cartes = $$('.avis', piste);
      if (cartes.length < 2) return;

      var points = $('[data-avis-points]', racine);
      var auto = null, visible = true;

      function parVue() {
        // Nombre de cartes reellement visibles : evite des points inutiles
        // quand trois avis tiennent deja cote a cote.
        return Math.max(1, Math.round(piste.clientWidth / cartes[0].offsetWidth));
      }
      function pages() { return Math.max(1, Math.ceil(cartes.length / parVue())); }
      function pageCourante() {
        return Math.round(piste.scrollLeft / piste.clientWidth);
      }

      function construirePoints() {
        if (!points) return;
        points.innerHTML = '';
        for (var i = 0; i < pages(); i++) {
          (function (n) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('role', 'tab');
            b.setAttribute('aria-label', 'Avis ' + (n + 1));
            b.addEventListener('click', function () { aller(n); stop(); });
            points.appendChild(b);
          })(i);
        }
        majPoints();
      }
      function majPoints() {
        if (!points) return;
        var cur = pageCourante();
        $$('button', points).forEach(function (b, i) {
          b.setAttribute('aria-selected', i === cur ? 'true' : 'false');
        });
      }
      function aller(n) {
        piste.scrollTo({ left: n * piste.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }
      function bouger(pas) {
        var n = pageCourante() + pas;
        if (n < 0) n = pages() - 1;
        if (n >= pages()) n = 0;
        aller(n);
      }

      var prev = $('[data-avis-prev]', racine), next = $('[data-avis-next]', racine);
      if (prev) prev.addEventListener('click', function () { bouger(-1); stop(); });
      if (next) next.addEventListener('click', function () { bouger(1); stop(); });

      piste.addEventListener('scroll', majPoints, { passive: true });
      window.addEventListener('resize', construirePoints);
      onCleanup(function () { window.removeEventListener('resize', construirePoints); });

      /* Defilement automatique : suspendu au survol, au focus clavier, onglet
         masque et section hors ecran. Jamais lance sous reduction d'animation
         — un carrousel qui bouge tout seul est un obstacle pour beaucoup de
         personnes. */
      function demarrer() {
        if (reduce || auto || !visible) return;
        if (racine.getAttribute('data-avis-auto') === 'false') return;
        auto = setInterval(function () { bouger(1); }, 5200);
      }
      function stop() { if (auto) { clearInterval(auto); auto = null; } }

      racine.addEventListener('pointerenter', stop);
      racine.addEventListener('focusin', stop);
      racine.addEventListener('pointerleave', demarrer);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else demarrer();
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          visible = en[0].isIntersecting;
          if (visible) demarrer(); else stop();
        }, { threshold: 0.25 });
        io.observe(racine);
        onCleanup(function () { io.disconnect(); });
      }
      onCleanup(stop);

      piste.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); bouger(1); stop(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); bouger(-1); stop(); }
      });

      construirePoints();
      demarrer();
    });
  }

  /* ====================================================== HERO */
  function initHero() {
    var shot = $('[data-hero-shot]');
    if (!shot || reduce || document.body.classList.contains('anim-none')) return;
    shot.classList.add('tilt');
    var tick = false;
    function frame() {
      tick = false;
      var y = window.pageYOffset, vh = window.innerHeight;
      var flat = Math.max(0, Math.min(1, y / (vh * 0.5)));
      shot.style.setProperty('--flat', flat.toFixed(3));
    }
    function onS() { if (!tick) { tick = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onS, { passive: true });
    frame();
    onCleanup(function () { window.removeEventListener('scroll', onS); });
  }

  /* ====================================================== HALO POINTEUR */
  function initSpot() {
    if (!hover || reduce || document.body.classList.contains('anim-none')) return;
    $$('[data-spot]').forEach(function (c) {
      c.classList.add('spot');
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--sx', (e.clientX - r.left) + 'px');
        c.style.setProperty('--sy', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ====================================================== LIGHTBOX */
  function initLightbox() {
    var lb = $('#Lightbox');
    if (!lb) return;
    var img = $('#LightboxImg', lb), leg = $('#LightboxCap', lb);
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-lightbox]') : null;
      if (!t) return;
      e.preventDefault();
      img.src = t.getAttribute('data-lightbox');
      img.alt = t.getAttribute('data-lightbox-alt') || '';
      if (leg) leg.textContent = t.getAttribute('data-lightbox-cap') || '';
      Overlay.ouvrir(lb);
    });
  }

  /* ====================================================== DEMO MODULES */
  function initDemo() {
    var racine = $('[data-demo]');
    if (!racine) return;

    var donnees;
    try { donnees = JSON.parse($('[data-demo-json]', racine).textContent); }
    catch (e) { return; }
    if (!donnees || !donnees.length) return;

    var idx = 0, famille = 'tout', autoplay = null, visible = true;
    var imgA = $('[data-demo-a]', racine), imgB = $('[data-demo-b]', racine);
    var actif = imgA;
    var elCat = $('[data-demo-cat]', racine), elTitre = $('[data-demo-title]', racine);
    var elDesc = $('[data-demo-desc]', racine), elCount = $('[data-demo-count]', racine);
    var items = $$('[data-demo-item]', racine);
    var pills = $$('[data-demo-fam]', racine);

    function liste() {
      return donnees.map(function (d, i) { return i; })
        .filter(function (i) { return famille === 'tout' || donnees[i].fam === famille; });
    }

    /* Les captures existent en deux ambiances. On derive la variante sombre
       du nom de fichier — en tenant compte du `?v=` que Shopify ajoute a
       toutes les URL d'assets, sinon l'expression ne trouve jamais rien. */
    function source(d) {
      var base = d.src;
      if (document.documentElement.getAttribute('data-scheme') === 'light') return base;
      if (base.indexOf('-dark-') !== -1) return base;
      return base.replace(/-(\d+)\.webp(\?|$)/, '-dark-$1.webp$2');
    }

    function precharge(i) {
      var l = liste(); var p = l.indexOf(i);
      if (p < 0) return;
      var suiv = l[(p + 1) % l.length];
      if (donnees[suiv]) { var im = new Image(); im.src = donnees[suiv].src; }
    }

    function afficher(i, focus) {
      var d = donnees[i];
      if (!d) return;
      idx = i;
      var voulue = source(d);
      // La premiere capture est deja rendue par Liquid. Dans ce cas on NE
      // permute PAS : `entrant` vaudrait `actif`, et poser() ajouterait la
      // classe avant de la retirer sur le meme element — l'ecran resterait
      // noir, et le resterait pour toutes les captures suivantes.
      if (actif.getAttribute('src') === voulue) {
        actif.classList.add('on');
      } else {
        // Fondu croise sur deux calques : un seul <img> dont on change `src`
        // provoquerait un flash blanc pendant le decodage.
        var entrant = actif === imgA ? imgB : imgA;
        var sortant = actif;
        entrant.src = voulue;
        entrant.alt = d.alt || '';
        var poser = function () {
          entrant.classList.add('on');
          if (sortant !== entrant) sortant.classList.remove('on');
          actif = entrant;
        };
        if (entrant.complete) poser(); else entrant.onload = poser;
      }

      if (elCat) elCat.textContent = d.fam;
      if (elTitre) elTitre.textContent = d.title;
      if (elDesc) elDesc.textContent = d.desc;
      var l = liste();
      if (elCount) elCount.textContent = (l.indexOf(i) + 1) + ' / ' + l.length;
      items.forEach(function (b, k) {
        var on = k === i;
        b.setAttribute('aria-current', on ? 'true' : 'false');
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        if (on && focus) b.focus();
        if (on) {
          // Defilement contenu dans la barre laterale : scrollIntoView ferait
          // remonter la fenetre entiere quand la section est hors ecran.
          var box = b.parentNode, rb = b.getBoundingClientRect(), rp = box.getBoundingClientRect();
          if (rb.top < rp.top) box.scrollTop -= (rp.top - rb.top) + 8;
          else if (rb.bottom > rp.bottom) box.scrollTop += (rb.bottom - rp.bottom) + 8;
        }
      });
      precharge(i);
      announce(d.title);
    }

    function bouger(pas, focus) {
      var l = liste();
      var p = l.indexOf(idx);
      if (p < 0) p = 0;
      afficher(l[(p + pas + l.length) % l.length], focus);
    }

    items.forEach(function (b, k) {
      b.addEventListener('click', function () { afficher(k); stop(); });
    });
    var prev = $('[data-demo-prev]', racine), next = $('[data-demo-next]', racine);
    if (prev) prev.addEventListener('click', function () { bouger(-1); stop(); });
    if (next) next.addEventListener('click', function () { bouger(1); stop(); });

    var diapos = $$('.dm-slide', racine);

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        famille = p.getAttribute('data-demo-fam');
        pills.forEach(function (o) { o.setAttribute('aria-pressed', o === p ? 'true' : 'false'); });
        items.forEach(function (b, k) {
          b.hidden = !(famille === 'tout' || donnees[k].fam === famille);
        });
        // Le carrousel mobile doit suivre le meme filtre : sans cela, cliquer
        // une famille sur telephone ne produisait aucun effet visible, car
        // seule la version bureau — masquee — etait mise a jour.
        diapos.forEach(function (d, k) {
          d.hidden = !(famille === 'tout' || donnees[k].fam === famille);
        });
        var piste = $('[data-demo-track]', racine);
        if (piste) piste.scrollTo({ left: 0, behavior: 'auto' });
        var l = liste();
        if (l.length) afficher(l[0]);
        stop();
      });
    });

    racine.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); bouger(1, true); stop(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); bouger(-1, true); stop(); }
    });

    /* Lecture automatique : suspendue au survol, au focus, quand l'onglet est
       masque et quand la section quitte l'ecran. Jamais active si le visiteur
       demande a reduire les animations. */
    var btnPlay = $('[data-demo-play]', racine);
    function demarrer() {
      if (reduce || autoplay || !visible) return;
      autoplay = setInterval(function () { bouger(1); }, 4200);
      if (btnPlay) btnPlay.setAttribute('aria-pressed', 'true');
    }
    function stop() {
      if (autoplay) { clearInterval(autoplay); autoplay = null; }
      if (btnPlay) btnPlay.setAttribute('aria-pressed', 'false');
    }
    if (btnPlay) {
      btnPlay.addEventListener('click', function () { autoplay ? stop() : demarrer(); });
    }
    racine.addEventListener('pointerenter', stop);
    racine.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        if (!visible) stop();
      }, { threshold: 0.25 });
      io.observe(racine);
      onCleanup(function () { io.disconnect(); });
    }
    onCleanup(stop);

    /* --- Version mobile : defilement natif avec accroche, pas de swipe
       simule. Le geste vertical de la page reste donc totalement libre. */
    var piste = $('[data-demo-track]', racine);
    if (piste) {
      var mCount = $('[data-demo-mcount]', racine);
      var maj = function () {
        var i = Math.round(piste.scrollLeft / piste.clientWidth);
        if (mCount) mCount.textContent = (i + 1) + ' / ' + piste.children.length;
      };
      piste.addEventListener('scroll', maj, { passive: true });
      maj();
      var mp = $('[data-demo-mprev]', racine), mn = $('[data-demo-mnext]', racine);
      var glisse = function (d) {
        piste.scrollBy({ left: d * piste.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      };
      if (mp) mp.addEventListener('click', function () { glisse(-1); });
      if (mn) mn.addEventListener('click', function () { glisse(1); });
    }

    /* Les diapositives mobiles sont rendues par Liquid en version claire :
       on les aligne sur le mode courant, sinon la demo reste blanche en mode
       sombre sur telephone. */
    function majDiapos() {
      var clair = document.documentElement.getAttribute('data-scheme') === 'light';
      $$('.dm-slide img', racine).forEach(function (im) {
        var src = im.getAttribute('src') || '';
        var voulu = clair ? src.replace('-dark-', '-')
                          : (src.indexOf('-dark-') === -1
                             ? src.replace(/-(\d+)\.webp(\?|$)/, '-dark-$1.webp$2') : src);
        if (voulu !== src) im.setAttribute('src', voulu);
        var ss = im.getAttribute('srcset');
        if (ss) {
          var vs = clair ? ss.replace(/-dark-/g, '-')
                         : (ss.indexOf('-dark-') === -1
                            ? ss.replace(/-(\d+)\.webp/g, '-dark-$1.webp') : ss);
          if (vs !== ss) im.setAttribute('srcset', vs);
        }
      });
    }
    majDiapos();

    window.weblyRedessinerDemo = function () { afficher(idx); majDiapos(); };

    afficher(0);
  }

  /* ====================================================== INITIALISATION */
  function init() {
    initScheme();
    initNav(); initReveals(); initCounters(); initFaq(); initFaqRepli(); initAvis();
    initHero(); initSpot(); initLightbox(); initDemo();
  }
  function detruire() {
    cleanups.forEach(function (fn) { try { fn(); } catch (e) {} });
    cleanups = [];
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Editeur Shopify : rejouer l'initialisation apres chaque rechargement de
     section, et nettoyer avant de la retirer. */
  document.addEventListener('shopify:section:load', function () { detruire(); init(); });
  document.addEventListener('shopify:section:unload', detruire);
  document.addEventListener('shopify:section:select', function (e) {
    var d = $('[data-demo]', e.target);
    if (d) d.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
})();
